import { SummaryRow } from '../../../Summary/SummaryRow';
import { VQ } from '../../../../store/student/types';
import { IVisaPrepForm } from '../../../../types';

function VisaPrepFeedbackInfo(props: IVisaPrepForm) {
  return (
    <>
      <SummaryRow
        className={'visa-summary'}
        key={VQ.OTHER_FEEDBACK}
        value={props.otherFeedback}
        label={'Other feedback'}
        fullLabel={'Is there any other information you wish to be considered as part of your application?'}
      />
      <SummaryRow
        className={'visa-summary'}
        key={VQ.DIFFICULTIES_FEEDBACK}
        value={props.difficultiesFeedback}
        label={'Any difficulties'}
        fullLabel={'If you have any difficulties with any question or require clarity, please list the question here:'}
      />
    </>
  );
}

export default VisaPrepFeedbackInfo;
